import { createReducer, createStandardAction } from 'typesafe-actions'
import { DrinkTypes } from 'types/DrinkTypes'

export interface ConsumptionState {
  isFemale: boolean
  drinks: { [P in DrinkTypes]: number }
}

// Construct the initial state – loop through all available drink types and set
// them to 0
const initialDrinkState = Object.values(DrinkTypes).reduce(
  (previousValue, currentValue) => {
    previousValue[currentValue] = 0
    return previousValue
  },
  {}
)

export const defaultConsumption: ConsumptionState = {
  isFemale: false,
  drinks: initialDrinkState
}

export const setFemale = createStandardAction('SET_FEMALE')<boolean>()
export const setNumber = createStandardAction('SET_NUMBER_OF_DRINKS')<
  number,
  DrinkTypes
>()

export const reducer = createReducer(defaultConsumption)
  .handleAction(setFemale, (state, { payload }) => ({
    ...state,
    isFemale: payload
  }))
  .handleAction(setNumber, (state, { payload, meta }) => ({
    ...state,
    drinks: {
      ...state.drinks,
      [meta]: payload
    }
  }))
